// import React from 'react';
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import classnames from "classnames";

import Config from "../../Config.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import QRCode from "qrcode.react";
import DOMPurify from "dompurify";
import { videoTagString, VideoTag } from "react-video-tag";
import ModalVideo from "react-modal-video";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import YouTube from "react-youtube";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import renderHTML from "react-render-html";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js";

require("codemirror/mode/xml/xml.js");
require("codemirror/mode/javascript/javascript.js");

const Productinformation = ({ props }) => {
  let history = useHistory();
  const location = useLocation();
  const [ProductID, setProductID] = useState(location?.state?.ProductID);
  const [TargetID, setTargetID] = useState(location?.state?.TargetID);
  // console.log("setTargetID===>", TargetID)
  // console.log("setProductID===>", ProductID)
  const [activePill, setactivePill] = useState("0");
  const [articleSegmentList, setarticleSegmentList] = useState([]);
  const [articleSegmentWebLinkList, setarticleSegmentWebLinkList] = useState(
    []
  );
  const [SegmentDescription, setSegmentDescription] = useState("");
  const [SegmentDescriptionError, setSegmentDescriptionError] = useState("");
  const [VideosegmentList, setVideosegmentList] = useState([]);
  const [ArticleSegmentDocumentlist, setArticleSegmentDocumentlist] = useState(
    []
  );
  const [ArticleSegmentImageLists, setArticleSegmentImageLists] = useState([]);
  const [ArticleSegmentID, setArticleSegmentID] = useState("");
  const [ArticleName, setArticleName] = useState("");
  const [variantList, setvariantList] = useState("");

  const [articleCategoryName, setarticleCategoryName] = useState([]);
  const [articlesubCategoryName, setarticlesubCategoryName] = useState([]);
  const [articlePrice, setarticlePrice] = useState("");
  const [articleRegularPrice, setarticleRegularPrice] = useState("");
  const [Currency, setCurrency] = useState(null);
  const [articlelable, setarticlelable] = useState();
  const [articlelableImagePath, setarticlelableImagePath] = useState();

  const [articleinfo, setarticleinfo] = useState();
  const [productCreatedDate, setproductCreatedDate] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [ModalVideoPlayer, setModalVideoPlayer] = useState(false);
  const [VideoPlayerItem, setVideoPlayerItem] = useState("");
  const [Qrodedetails, setQrodedetails] = useState(null);
  const [segmentinfo, setsegmentinfo] = useState(null);
  const [CombinationDetails, setCombinationDetails] = useState(null);
  const [selectCombinationID, setselectCombinationID] = useState("");

  const [shortDescription, setShortDescription] = useState("");

  const [VideoPlayerFilePath, setVideoPlayerFilePath] = useState("");

  const domainFrontUrl = useRef("");

  const reyurnperamiter = (item) => {
    let itemobj = item.split("https://www.youtube.com/watch");
    // console.log("item", itemobj)
    return new URLSearchParams(itemobj[1]).get("v");
    //    console.log("IdPraveen=>",ID)
  };
  const toggleVideoPlayer = (item) => {
    // console.log("item===>", item)
    setModalVideoPlayer(!ModalVideoPlayer);
    setVideoPlayerItem(item);
  };
  const opts = {
    height: "200",
    width: "280",
    // playerVars: {
    //     // https://developers.google.com/youtube/player_parameters
    //     autoplay: 1,
    // },
  };
  const downloadImage = (Url, filename) => {
    window.open(Config.contentUrl + Url, "_blank");
    // Url = Config.contentUrl + Url;
    //saveAs(Url, filename) // Put your image url here.
  };
  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    }
  }, []);
  useEffect(() => {
    getDominUrl();
    GetAllProductInfo(ProductID);
    GetAllQrCodeInformation(TargetID);
  }, []);


  const getDominUrl = async () => {
    let response = await GetDominUrl();
    if (response !== null && response.domainName !== null && response.domainName !== "") {
      domainFrontUrl.current = response.domainName;
    }
    else {
      domainFrontUrl.current = "";
    }
  }
  const togglePill = (pill) => {
    if (activePill !== pill) {
      setactivePill(pill);
    }
  };
  const ArticleSegmentchanged = (item, Index) => {
    let Tempsegment = [...articleSegmentList];
    if (Tempsegment.length > 0) {
      Tempsegment.map((SegmentItem) => {
        if (SegmentItem._id === item._id) {
          SegmentItem.isDeleted = true;
        } else {
          SegmentItem.isDeleted = false;
        }
      });
    }
    ArticleSegmentgetbyId(item._id);
    setarticleSegmentList(Tempsegment);
  };

  const GetAllCombinationInfo = async (CombinationID) => {
    if (
      CombinationID != null &&
      CombinationID != undefined &&
      CombinationID != ""
    ) {
      fetch(
        Config.apiUrl +
        "AttributeValueMap/ByIdwithoutUserid?id=" +
        CombinationID,
        {
          headers: {
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      )
        .then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              if (
                resp?.articleID != null &&
                resp?.articleID != "" &&
                resp?.articleID != undefined
              ) {
                setselectCombinationID(CombinationID);
                setCombinationDetails(resp);
              }
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
      // setisLoading(false);
    }
  };
  const GetAllProductInfo = (articleidObj) => {
    if (
      articleidObj !== null &&
      articleidObj !== "" &&
      articleidObj !== undefined &&
      articleidObj !== "undefined"
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetArticleAllInformation?id=" +
        articleidObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result != null) {
            // console.log("ProductInformation result=====>", result)
            setarticleinfo(result);
            setArticleName(result.articleName);
            setShortDescription(result?.shortDescription ? result?.shortDescription : "");
            if (result.categorydetail != null && result.categorydetail != "") {
              setarticleCategoryName(result.categorydetail.name);
              if (
                result.subCategoryDetail != null &&
                result.subCategoryDetail != ""
              ) {
                setarticlesubCategoryName(result.subCategoryDetail.name);
              }
            }
            if (
              result.articleAttribute != null &&
              result.articleAttribute != ""
            ) {
              setvariantList(result.articleAttribute);
            }
            if (result.sellPrice != null && result.sellPrice != "") {
              setarticlePrice(result.sellPrice);
            } else {
              setarticlePrice("0");
            }
            if (result.regularPrice != null && result.regularPrice != "") {
              setarticleRegularPrice(result.regularPrice);
            } else {
              setarticleRegularPrice("0");
            }
            if (
              result?.currencyDetail != null &&
              result?.currencyDetail != undefined &&
              result?.currencyDetail != ""
            ) {
              setCurrency(result?.currencyDetail?.otherName);
            }
            if (result.labelDetail != null && result.labelDetail != "") {
              setarticlelable(result.labelDetail.name);
              setarticlelableImagePath(
                Config.contentUrl + result.labelDetail.logoPath
              );
            }
            // if (result.attribute !== null && result.attribute !== undefined && result.attribute !== "") {
            // setproductAttribute(result.attribute)
            // }
            // if (result.vender !== null && result.vender !== undefined && result.vender !== "") {
            // setproductvender(result.vender)
            // }
            // if (result.manufectureDate !== null && result.manufectureDaate !== undefined && result.manufectureDaate !== "") {
            // setproductManufectureDate(result.manufectureDate)
            // }
            if (
              result.createdDate !== null &&
              result.createdDate !== undefined &&
              result.createdDate !== ""
            ) {
              setproductCreatedDate(result.createdDate);
            }
            if (
              result.aarticleProductSegment != null &&
              result.aarticleProductSegment != ""
            ) {
              result.aarticleProductSegment[0].isDeleted = true;
              setarticleSegmentList(result.aarticleProductSegment);
              var first = result.aarticleProductSegment[0];
              ArticleSegmentgetbyId(first._id);
            }
          } else {
            setarticleSegmentList([]);
          }
        });
      });
    }
  };
  const GetAllQrCodeInformation = (targetId) => {
    if (
      targetId !== null &&
      targetId !== "" &&
      targetId !== undefined &&
      targetId !== "undefined"
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/WebByIdWithOutUserID?id=" +
        targetId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then(async (result) => {
          if (result?.targetType === "productqrcodeattributes") {
            await GetAllCombinationInfo(result?.targetID);
          }
          setQrodedetails(result);
          // console.log("WrCodeInformation==>",result)
        });
      });
    } else {
      setQrodedetails(null);
    }
  };
  const ArticleSegmentgetbyId = (ArticleSegmentID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "ArticleProductSegment/SegmentFileById?segmentid=" +
      ArticleSegmentID,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((response) => {
      response.json().then((result) => {
        if (result !== null) {
          setsegmentinfo(result);
          //setArticleID(result.articleID);
          if (result.description != null) {
            setSegmentDescription(result.description);
          } else {
            setSegmentDescription("");
          }

          if (result.articleVideo != null) {
            setVideosegmentList(result.articleVideo);
          } else {
            setVideosegmentList([]);
          }
          if (result.articleDocument != null) {
            setArticleSegmentDocumentlist(result.articleDocument);
          } else {
            setArticleSegmentDocumentlist([]);
          }
          if (result.articleExternalLinkList != null) {
            setarticleSegmentWebLinkList(result.articleExternalLinkList);
          } else {
            setarticleSegmentWebLinkList([]);
          }
          if (result.articleSegmentImage != null) {
            setArticleSegmentImageLists(result.articleSegmentImage);
          } else {
            setArticleSegmentImageLists([]);
          }
          setArticleSegmentID(ArticleSegmentID);
        }
      });
    });
  };
  const EditArticleDetails = (ArticleIdObj) => {
    if (ArticleIdObj === "") {
      history.push("Login1");
    } else {
      history.push({
        pathname: "/product-addnew",
        state: { EditArticleDetailsID: ArticleIdObj },
      });
    }
  };
  // const convertHtml = (htmlInput) => {
  //   if (htmlInput != null && htmlInput != "" && htmlInput != undefined) {
  //     const mySafeHTML = DOMPurify.sanitize(htmlInput);
  //     return <div dangerouslySetInnerHTML={{ __html: mySafeHTML }} />;
  //   }
  // };
  return (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <a href="/home">Home</a>
        </li>

        <li className="breadcrumb-item active">Product information</li>
      </ol>
      <h1 className="page-header">Product information</h1>
      {articleinfo && (
        <>
          <Panel>
            <PanelHeader>
              <div>
                Product
                {articleinfo?.isshow ? (
                  <button
                    className="btn btn-primary shadow-add  m-l-10 "
                    onClick={(e) => {
                      EditArticleDetails(ProductID);
                    }}
                  >
                    <i class="fas fa-lg fa-fw m-r-5 fa-pencil-alt icon"></i> Edit
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </PanelHeader>
            <PanelBody>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xl-8 col-xxl-8 col-lg-12 col-md-12">
                    <div className="row ">
                      <div className="col-lg-7">
                        <div className="product-image-main-container">
                          <div className="tabimgmaincontainer product-images">
                            {articleinfo?.articleImage?.length > 0 ? (
                              articleinfo?.articleImage?.map((item, i) => (
                                <button className="Link">
                                  <img
                                    src={Config.contentUrl + item?.filePath}
                                    alt="img"
                                  />
                                </button>
                              ))
                            ) : (
                              <></>
                            )}
                          </div>
                          {articleinfo?.articleImage?.length > 0 ? (
                            <div className="main-product-image">
                              <img
                                src={
                                  Config.contentUrl +
                                  articleinfo?.articleImage[0].filePath
                                }
                                style={{ marginLeft: 10 }}
                                className="rounded"
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>

                      </div>
                      <div className="col-lg-5">
                        <h2 className="mb-0"> {ArticleName}</h2>
                        {/* <span class="badge bg-yellow text-black">BUY 3 FOR 999</span> */}
                        {/* <h1 className='mb-2'>${articlePrice}</h1> */}
                        {articlePrice !== "0" ? (
                          <div className="d-flex">
                            <h1 className="mb-2 mr-2 text-decoration-line-through text-red">
                              {
                                (articleRegularPrice !== null && articleRegularPrice !== "" &&
                                  articleRegularPrice !== undefined && articleRegularPrice !== 0 && articleRegularPrice !== "0") && (
                                  <NumericFormat
                                    prefix={Currency ? Currency : ""}
                                    displayType="text"
                                    thousandSeparator={true}
                                    className=""
                                    placeholder="Regular Price"
                                    decimalScale={2}
                                    fixedDecimalScale={false}
                                    value={articleRegularPrice}
                                  />
                                )
                              }
                            </h1>
                            {"  "}
                            <h1 className="mb-2">
                              {
                                (articlePrice !== null && articlePrice !== "" &&
                                  articlePrice !== undefined && articlePrice !== 0 && articlePrice !== "0") && (
                                  <NumericFormat
                                    prefix={Currency ? Currency : ""}
                                    displayType="text"
                                    thousandSeparator={true}
                                    className=""
                                    placeholder="Regular Price"
                                    decimalScale={2}
                                    fixedDecimalScale={false}
                                    value={articlePrice}
                                  />
                                )
                              }
                            </h1>
                          </div>
                        ) : (
                          <h1 className="mb-2">
                            {(articleRegularPrice !== null && articleRegularPrice !== "" &&
                              articleRegularPrice !== undefined && articleRegularPrice !== 0 && articleRegularPrice !== "0") && (
                                <NumericFormat
                                  prefix={Currency ? Currency : ""}
                                  displayType="text"
                                  thousandSeparator={true}
                                  className=""
                                  placeholder="Regular Price"
                                  decimalScale={2}
                                  fixedDecimalScale={false}
                                  value={articleRegularPrice}
                                />
                              )}
                          </h1>
                        )}
                        <div>
                          {variantList.length > 0 ? (
                            <>
                              <div className="titlebgcontainer">
                                <b className="mb-0">Variant Combination</b>
                              </div>
                              {
                                variantList.map((variantItem) => {
                                  return (
                                    <div className="form-group row m-t-3 m-b-0">
                                      <label className="col-form-label col-md-12">
                                        {"Select" + " " + variantItem.attributeName}{" "}
                                      </label>
                                      <div className="col-md-12">
                                        <select className="form-control">
                                          {variantItem.articleAttributeValue.length >
                                            0 ? (
                                            variantItem.articleAttributeValue.map(
                                              (variantsubItem) => {
                                                return (
                                                  <option val={variantsubItem._id}>
                                                    {variantsubItem.value}
                                                  </option>
                                                );
                                              }
                                            )
                                          ) : (
                                            <></>
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  );
                                })
                              }
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        {Qrodedetails && (
                          <>
                            <b className="mb-3 mt-3 ">Production data</b>
                            <table class="table dash">
                              <tbody>
                                <tr>
                                  <td>Batch No</td>
                                  <td>
                                    {Qrodedetails?.batchnumber
                                      ? Qrodedetails?.batchnumber
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Combination</td>
                                  <td>
                                    {CombinationDetails ? (
                                      <>
                                        {CombinationDetails?.attributeValue1 +
                                          " " +
                                          CombinationDetails?.attributeValue2 +
                                          " " +
                                          CombinationDetails?.attributeValue3 +
                                          " " +
                                          CombinationDetails?.attributeValue4 +
                                          " " +
                                          CombinationDetails?.attributeValue5}
                                      </>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Manufacture date</td>
                                  <td>
                                    {" "}
                                    {Qrodedetails?.manufacturedate
                                      ? moment(
                                        Qrodedetails?.manufacturedate
                                      ).format("DD-MM-YYYY")
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Expiry date</td>
                                  <td>
                                    {" "}
                                    {Qrodedetails?.expirydate
                                      ? moment(Qrodedetails?.expirydate).format(
                                        "DD-MM-YYYY"
                                      )
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Vendor</td>
                                  <td>
                                    {" "}
                                    {Qrodedetails?.vendorDetail?.name
                                      ? Qrodedetails?.vendorDetail?.name
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Created date</td>
                                  <td>
                                    {Qrodedetails?.createdDate
                                      ? moment(Qrodedetails?.createdDate).format(
                                        "DD-MM-YYYY"
                                      )
                                      : "N/A"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                      </div>
                      {/* Next  */}
                      <div className="col-lg-12">
                        {shortDescription !== null &&
                          shortDescription !== "" ? (
                          <div className="titlebgcontainer mt-3">
                            <b className="mb-0">
                              Description{" "}
                            </b>
                          </div>
                        ) : (
                          <></>
                        )}
                        <p style={{ padding: 10 }}>
                          {shortDescription !== null &&
                            shortDescription !== "" ? (
                            <div className="ckeditor-text-new">
                              {renderHTML(shortDescription)}
                            </div>
                          ) : (
                            <></>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-xxl-4 col-lg-12 col-md-12">
                    <div className="row">

                      <div className="col-sm-12">
                        <div>
                          <div className="titlebgcontainer">
                            <b className="mb-0">Category </b>
                          </div>
                          <p className="mb-0 px-2 py-2">
                            {articleCategoryName + "/" + articlesubCategoryName}
                          </p>
                        </div>
                        <div>
                          <div className="titlebgcontainer">
                            <b className="mb-0">Label </b>
                          </div>
                          <div className="d-flex align-items-center py-2">
                            <img
                              src={articlelableImagePath}
                              className=""
                              style={{
                                height: "60px",
                                width: "60px",
                                objectFit: "cover",
                              }}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "../assets/img/noimage.jpg";
                              }}
                            />
                            <p className="mb-0 px-2">{articlelable}</p>
                          </div>
                        </div>
                        <div>
                          <div className="titlebgcontainer">
                            <b className="mb-0">Certificates </b>
                          </div>
                          <div className="py-2">
                            {articleinfo?.certificateDetail?.length > 0 ? (
                              articleinfo?.certificateDetail.map((item, i) => (
                                <div className="d-flex align-items-center py-1">
                                  <img
                                    src={Config.contentUrl + item._LogoPath}
                                    className="p-1"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      objectFit: "cover",
                                    }}
                                  />

                                  <p className="mb-0 px-2">{item?.name}</p>
                                </div>
                              ))
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="titlebgcontainer">
                            <b className="mb-0">Qr Code </b>
                          </div>
                          <div className="row py-2 px-2">
                            <div className="col-xs-12 text-center">
                              {articleinfo?.qrCodePath !== null &&
                                articleinfo?.qrCodePath !== "" &&
                                articleinfo?.qrCodePath !== undefined ? (
                                <QRCode
                                  // value={Config.FrontUrl+ articleinfo?.qrCodePath}
                                  value={domainFrontUrl.current + articleinfo?.qrCodePath}
                                  id="qrCodeEl"
                                  style={{ height: "250px", width: "250px" }}
                                />
                              ) : (
                                <img
                                  src="/assets/img/new-Images/qr-code-scanner.jpg"
                                  style={{ height: "200px" }}
                                ></img>
                              )}
                              {/* <img src="../assets/img/user/QR.png" alt="img" className='img-fluid ' style={{ height: '200px', width: '200px' }} /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
          <Panel>
            <PanelHeader>
              <div>
                Product Description
                {articleinfo?.isshow ? (
                  <button
                    className="btn btn-primary shadow-add  m-l-10 "
                    onClick={(e) => {
                      EditArticleDetails(ProductID);
                    }}
                  >
                    <i class="fas fa-lg fa-fw m-r-5 fa-pencil-alt icon"></i> Edit
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </PanelHeader>
            <PanelBody>
              <Nav className="mb-3" pills>
                {articleSegmentList.map((x, i) => {
                  return (
                    <NavItem className="mr-2">
                      <NavLink
                        className={classnames({ active: x.isDeleted === true })}
                        //</NavItem>onClick={() => { togglePill('1'); }}
                        onClick={(e) => {
                          ArticleSegmentchanged(x, i);
                        }}
                      >
                        <span className="d-sm-none">
                          {x.title}{" "}
                          {articleinfo?.isArticleDescriptionDisplay === true ? (
                            <small className="mb-0 text-success">
                              <b>( Published </b>)
                            </small>
                          ) : (
                            <small className="mb-0 text-danger">
                              <b>( Unpublished )</b>
                            </small>
                          )}
                        </span>
                        <span className="d-sm-block d-none">
                          {x.title}{" "}
                          {articleinfo?.isArticleDescriptionDisplay === true ? (
                            <small className="mb-0 text-success">
                              <b>( Published </b>)
                            </small>
                          ) : (
                            <small className="mb-0 text-danger">
                              <b>( Unpublished )</b>
                            </small>
                          )}
                        </span>
                      </NavLink>
                    </NavItem>
                  );
                })}
              </Nav>
              {articleinfo ? (
                <TabContent className="p-15 rounded bg-white mb-4">
                  <TabPane>
                    <Panel className="border" theme="success">
                      <PanelHeader>Product Detail</PanelHeader>
                      <PanelBody>
                        <div className="container">
                          <div className="row">
                            <div className="col-xxl-5 col-xl-5 col-lg-12 col-md-12 mt-2">
                              {ArticleSegmentImageLists?.length > 0 ? (
                                <div className="titlebgcontainer mb-5">
                                  <b className="mb-0">
                                    Product Images{" "}
                                    {segmentinfo?.isArticleSegmentImageDisplay ===
                                      true ? (
                                      <small className="mb-0 text-success">
                                        <b>( Published </b>)
                                      </small>
                                    ) : (
                                      <small className="mb-0 text-danger">
                                        <b>( Unpublished )</b>
                                      </small>
                                    )}
                                  </b>
                                </div>
                              ) : (
                                <></>
                              )}
                              <div className="row ">
                                <div className="col-sm-3 tabimgmaincontainer ">
                                  {ArticleSegmentImageLists?.length > 0 ? (
                                    ArticleSegmentImageLists?.map((item, i) => (
                                      <button className="Link">
                                        <img
                                          src={Config.contentUrl + item.filePath}
                                          alt="img"
                                        />
                                      </button>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                {ArticleSegmentImageLists?.length > 0 ? (
                                  <div className="col-sm-9">
                                    {/* <img src="../assets/img/user/user-1.jpg" alt="img" height='250px' /> */}
                                    <img
                                      src={
                                        Config.contentUrl +
                                        ArticleSegmentImageLists[0].filePath
                                      }
                                      height="250px"
                                      width={"100%"}
                                    />
                                  </div>
                                ) : (
                                  <></>
                                )}

                              </div>
                            </div>
                            <div className="col-xl-7 col-xxl-7 col-lg-12 col-md-12 mt-2">
                              <div className="row">
                                <div className="col-md-12">
                                  {SegmentDescription.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Description{" "}
                                          {segmentinfo?.isArticleSegmentDescriptionDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <p className="px-3 py-3 mb-0">
                                        {SegmentDescription !== null &&
                                          SegmentDescription !== "" ? (
                                          // convertHtml(SegmentDescription)
                                          <div className="ckeditor-text-new">
                                            {renderHTML(SegmentDescription)}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </p>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {VideosegmentList.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Know more{" "}
                                          {segmentinfo?.isArticleSegmentVideoDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <div className="container-fluid px-3 py-3">
                                        {/* <div className='row knowmore-img'>
                                                                            {
                                                                                VideosegmentList.map((subscriber) => {
                                                                                    return <div className='col-sm-4 text-center'>
                                                                                        <VideoTag src={Config.contentUrl + subscriber.filePath} className="image-article imageUpload m-auto" />
                                                                                        <p className='mb-0'>
                                                                                            {subscriber.originalFileName}
                                                                                        </p>
                                                                                    </div>
                                                                                })
                                                                            }
                                                                        </div> */}
                                        <div className="row mt-4">
                                          {VideosegmentList.map((subscriber) => {
                                            return subscriber?.isYouTubeLink ===
                                              false ? (
                                              <div className="col-sm-4 text-center">
                                                <button
                                                  className="btn btn-link p-0 videotag bg-transparent"
                                                  onClick={() => { setVideoPlayerFilePath(subscriber.filePath); setOpen(true) }}
                                                >
                                                  <VideoTag
                                                    src={
                                                      Config.contentUrl +
                                                      subscriber.filePath
                                                    }
                                                    className="image-article imageUpload m-auto"
                                                  />
                                                  <p className="videotagtext text2line breakword">
                                                    {subscriber.originalFileName}
                                                  </p>
                                                  <div className="youtubeicon">
                                                    <i className="fab fa-lg fa-fw fa-youtube"></i>
                                                  </div>
                                                </button>
                                                {/* <ModalVideo
                                              channel="custom"
                                              autoplay={true}
                                              isOpen={isOpen}
                                              url={
                                                Config.contentUrl +
                                                subscriber.filePath
                                              }
                                              onClose={() => setOpen(false)}
                                            /> */}
                                              </div>
                                            ) : (
                                              // : <div className='col-sm-4 text-center'>
                                              //     <iframe
                                              //         src="http://www.youtube.com/embed/XGSy3_Czz8k"
                                              //         className="image-article imageUpload m-auto" />
                                              //     <embed src={subscriber?.youTubeLink} className="image-article imageUpload m-auto" />

                                              //     <p className='mb-0'>
                                              //         {subscriber.originalFileName}
                                              //     </p>
                                              // </div>
                                              <>
                                                <div className="col-sm-4 text-center">
                                                  <button
                                                    className="btn btn-link p-0 videotag bg-transparent"
                                                    onClick={() => {
                                                      toggleVideoPlayer(
                                                        reyurnperamiter(
                                                          subscriber?.youTubeLink
                                                        )
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={`https://i.ytimg.com/vi/${reyurnperamiter(
                                                        subscriber?.youTubeLink
                                                      )}/hqdefault.jpg`}
                                                      className="image-article imageUpload m-auto"
                                                    />
                                                    <p className="videotagtext text2line breakword">
                                                      {subscriber.youTubeLink}
                                                    </p>

                                                    <div className="youtubeicon">
                                                      <i className="fab fa-lg fa-fw fa-youtube"></i>
                                                    </div>
                                                  </button>
                                                  {/* <Modal
                                                isOpen={ModalVideoPlayer}
                                                toggle={toggleVideoPlayer}
                                                className="text-center modalcenter YoutubeModal"
                                              >
                                                <ModalBody>
                                                  <div>
                                                    <YouTube
                                                      videoId={VideoPlayerItem}
                                                      opts={opts}
                                                    />
                                                  </div>
                                                  <button
                                                    className="btn btn-link modalcolsebtn"
                                                    onClick={toggleVideoPlayer}
                                                  >
                                                    <i className="ion ion-md-close-circle fa-2x"></i>
                                                  </button>
                                                </ModalBody>
                                              </Modal> */}
                                                </div>
                                              </>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}

                                  <Modal
                                    isOpen={ModalVideoPlayer}
                                    toggle={toggleVideoPlayer}
                                    className="text-center modalcenter YoutubeModal"
                                  >
                                    <ModalBody>
                                      <div>
                                        <YouTube
                                          videoId={VideoPlayerItem}
                                          opts={opts}
                                        />
                                      </div>
                                      <button
                                        className="btn btn-link modalcolsebtn"
                                        onClick={toggleVideoPlayer}
                                      >
                                        <i className="ion ion-md-close-circle fa-2x"></i>
                                      </button>
                                    </ModalBody>
                                  </Modal>
                                  <ModalVideo
                                    channel="custom"
                                    autoplay={true}
                                    isOpen={isOpen}
                                    url={
                                      Config.contentUrl +
                                      VideoPlayerFilePath
                                    }
                                    onClose={() => { setVideoPlayerFilePath(""); setOpen(false) }}
                                  />
                                  {articleSegmentWebLinkList.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Explore further{" "}
                                          {segmentinfo.isArticleSegmentWebLinkDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <div className="container-fluid px-3 py-2">
                                        <div className="row">
                                          {articleSegmentWebLinkList.map(
                                            (WebData) => {
                                              return (
                                                <div className="col-sm-12">
                                                  <Link
                                                    to={{
                                                      pathname: WebData.linkURL,
                                                    }}
                                                    target="_blank"
                                                  >
                                                    <p className="mb-1">
                                                      {" "}
                                                      {WebData.linkURL}
                                                    </p>
                                                  </Link>
                                                  {/* <Link>
                                                                                            <p className='mb-1'> {WebData.linkURL}</p>
                                                                                        </Link> */}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {ArticleSegmentDocumentlist.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Know more{" "}
                                          {segmentinfo.isArticleSegmentDocumentDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <div className="container-fluid px-3 py-3">
                                        <div className="row pdfbtn">
                                          {ArticleSegmentDocumentlist.map(
                                            (DocumnetData) => {
                                              return (
                                                <div className="col-sm-3 text-center">
                                                  <button
                                                    onClick={(e) => {
                                                      downloadImage(
                                                        DocumnetData.filePath,
                                                        DocumnetData.originalFileName
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="../assets/img/new-images/Pdf.png"
                                                      className="img-fluid"
                                                    />
                                                  </button>
                                                  <p className="mb-0">
                                                    {DocumnetData.originalFileName}
                                                  </p>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                  </TabPane>
                </TabContent>
              ) : (
                <></>
              )}
            </PanelBody>
          </Panel>
        </>
      )}
    </div>
  );
};
export default Productinformation;
